import { forwardRef, useCallback, useImperativeHandle, useState } from 'react';

import { CheckEmail, DisableTFA, SetUpTFA } from '.';

export const TwoFA = forwardRef((props, ref) => {
  const [emailOpen, setEmailOpen] = useState<boolean>(false);
  const [TFAOpen, setTFAOpen] = useState<boolean>(false);
  const [DisTFAOpen, setDisTFAOpen] = useState<boolean>(false);

  const [captcha, setCaptcha] = useState<string>('');

  const verifySuccess = useCallback((captcha: string) => {
    setCaptcha(captcha);
    setEmailOpen(false);
    setTFAOpen(true);
  }, []);

  useImperativeHandle(ref, () => ({
    setEmailOpen,
    setDisTFAOpen,
  }));

  return (
    <>
      <CheckEmail
        open={emailOpen}
        setOpen={setEmailOpen}
        onSuccess={(captcha: string) => verifySuccess(captcha)}
      />
      <SetUpTFA open={TFAOpen} setOpen={setTFAOpen} captcha={captcha} />
      <DisableTFA open={DisTFAOpen} setOpen={setDisTFAOpen} />
    </>
  );
});
